import {Model} from "./Model";
import {IApiGameAccountDescription} from "../typings/apiResponse";

/**
 * @ngdoc overview
 *
 * @type {Object}
 * @name ngLeague.GameAccountDescription
 *
 * @requires apiResponse
 *
 * @description
 * The GameAccountDescription object represents a game account on ESL Play.
 */
export class GameAccountDescription extends Model {

    constructor(private apiResponse: IApiGameAccountDescription) {
        super(apiResponse);
    }

    public getType() {
        return this.apiResponse.type;
    }

    public getName() {
        return this.apiResponse.name;
    }

    public getDescription() {
        return this.apiResponse.description;
    }

    public getExample() {
        return this.apiResponse.example;
    }

    public getLink() {
        return this.apiResponse.link;
    }
}
